

export function mapAudio(audioObject: any) {
    if (typeof audioObject === 'object' && audioObject.default) {
        return audioObject.default
    } else {
        return audioObject
    }
}